import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import {
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ConditionSerializer2v4zqxahhdocs as ConditionSerializer } from './ConditionSerialization.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Always_getInstance177eud73uc475 as Always_getInstance } from './Condition.mjs';
import { DataClassPathSerializer2aqs8pcwb13zn as DataClassPathSerializer } from './DataClassPathSerializer.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { Companion_getInstance3e2h11tnt9mtt as Companion_getInstance } from './Aggregate.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.GroupCountQuery', null, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('condition', true);
        tmp0_serialDesc.addElement_5pzumi_k$('groupBy', false);
        this.$cachedDescriptor_1 = tmp0_serialDesc;
      }
      serializer_nrleg8_k$(typeSerial0) {
        return $serializer().new_com_lightningkite_services_database_GroupCountQuery_$serializer_vkvm81_k$(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_nrleg8_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        return new.target.new_com_lightningkite_services_database_GroupCountQuery_$serializer_mfpbnw_k$();
      }
      static new_com_lightningkite_services_database_GroupCountQuery_$serializer_mfpbnw_k$() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.GroupCountQuery', $this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('condition', true);
        tmp0_serialDesc.addElement_5pzumi_k$('groupBy', false);
        $this.descriptor_1 = tmp0_serialDesc;
        return $this;
      }
      serialize_d4uq4h_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !value.condition_1.equals(Always_getInstance())) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, new (ConditionSerializer())(this.typeSerial0__1), value.condition_1);
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, new (DataClassPathSerializer())(this.typeSerial0__1), value.groupBy_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_d4uq4h_k$(encoder, value instanceof GroupCountQuery() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, new (ConditionSerializer())(this.typeSerial0__1), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, new (DataClassPathSerializer())(this.typeSerial0__1), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, new (ConditionSerializer())(this.typeSerial0__1), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, new (DataClassPathSerializer())(this.typeSerial0__1), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return GroupCountQuery().new_com_lightningkite_services_database_GroupCountQuery_ik33fw_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [new (ConditionSerializer())(this.typeSerial0__1), new (DataClassPathSerializer())(this.typeSerial0__1)];
      }
      typeParametersSerializers_fr94fx_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.typeSerial0__1];
      }
      static new_com_lightningkite_services_database_GroupCountQuery_$serializer_vkvm81_k$(typeSerial0) {
        var $this = this.new_com_lightningkite_services_database_GroupCountQuery_$serializer_mfpbnw_k$();
        $this.typeSerial0__1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var GroupCountQueryClass;
function GroupCountQuery() {
  if (GroupCountQueryClass === VOID) {
    class $ {
      constructor(condition, groupBy) {
        Companion_getInstance_0();
        condition = condition === VOID ? Always_getInstance() : condition;
        this.condition_1 = condition;
        this.groupBy_1 = groupBy;
      }
      toString() {
        return 'GroupCountQuery(condition=' + toString(this.condition_1) + ', groupBy=' + this.groupBy_1.toString() + ')';
      }
      hashCode() {
        var result = this.condition_1.hashCode();
        result = imul(result, 31) + this.groupBy_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GroupCountQuery()))
          return false;
        if (!this.condition_1.equals(other.condition_1))
          return false;
        if (!this.groupBy_1.equals(other.groupBy_1))
          return false;
        return true;
      }
      static new_com_lightningkite_services_database_GroupCountQuery_ik33fw_k$(seen0, condition, groupBy, serializationConstructorMarker) {
        Companion_getInstance_0();
        if (!(2 === (2 & seen0))) {
          throwMissingFieldException(seen0, 2, Companion_getInstance_0().$cachedDescriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.condition_1 = Always_getInstance();
        else
          $this.condition_1 = condition;
        $this.groupBy_1 = groupBy;
        return $this;
      }
    }
    initMetadataForClass($, 'GroupCountQuery', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_0});
    GroupCountQueryClass = $;
  }
  return GroupCountQueryClass;
}
function AggregateQuery$Companion$$childSerializers$_anonymous__mdtkin() {
  return Companion_getInstance().serializer_9w0wvi_k$();
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [lazy(tmp_0, AggregateQuery$Companion$$childSerializers$_anonymous__mdtkin), null, null];
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.AggregateQuery', null, 3);
        tmp0_serialDesc.addElement_5pzumi_k$('aggregate', false);
        tmp0_serialDesc.addElement_5pzumi_k$('condition', true);
        tmp0_serialDesc.addElement_5pzumi_k$('property', false);
        this.$cachedDescriptor_1 = tmp0_serialDesc;
      }
      serializer_nrleg8_k$(typeSerial0) {
        return $serializer_0().new_com_lightningkite_services_database_AggregateQuery_$serializer_1o0sk_k$(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_nrleg8_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_1() {
  if (Companion_instance_0 === VOID)
    new (Companion_0())();
  return Companion_instance_0;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        return new.target.new_com_lightningkite_services_database_AggregateQuery_$serializer_k9vngx_k$();
      }
      static new_com_lightningkite_services_database_AggregateQuery_$serializer_k9vngx_k$() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.AggregateQuery', $this, 3);
        tmp0_serialDesc.addElement_5pzumi_k$('aggregate', false);
        tmp0_serialDesc.addElement_5pzumi_k$('condition', true);
        tmp0_serialDesc.addElement_5pzumi_k$('property', false);
        $this.descriptor_1 = tmp0_serialDesc;
        return $this;
      }
      serialize_n2zf0c_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_1().$childSerializers_1;
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, tmp2_cached[0].get_value_j01efc_k$(), value.aggregate_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !value.condition_1.equals(Always_getInstance())) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, new (ConditionSerializer())(this.typeSerial0__1), value.condition_1);
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, new (DataClassPathSerializer())(this.typeSerial0__1), value.property_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_n2zf0c_k$(encoder, value instanceof AggregateQuery() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp8_cached = Companion_getInstance_1().$childSerializers_1;
        if (tmp7_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp8_cached[0].get_value_j01efc_k$(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, new (ConditionSerializer())(this.typeSerial0__1), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, new (DataClassPathSerializer())(this.typeSerial0__1), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp8_cached[0].get_value_j01efc_k$(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, new (ConditionSerializer())(this.typeSerial0__1), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, new (DataClassPathSerializer())(this.typeSerial0__1), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp7_input.endStructure_1xqz0n_k$(tmp0_desc);
        return AggregateQuery().new_com_lightningkite_services_database_AggregateQuery_llps17_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [Companion_getInstance_1().$childSerializers_1[0].get_value_j01efc_k$(), new (ConditionSerializer())(this.typeSerial0__1), new (DataClassPathSerializer())(this.typeSerial0__1)];
      }
      typeParametersSerializers_fr94fx_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.typeSerial0__1];
      }
      static new_com_lightningkite_services_database_AggregateQuery_$serializer_1o0sk_k$(typeSerial0) {
        var $this = this.new_com_lightningkite_services_database_AggregateQuery_$serializer_k9vngx_k$();
        $this.typeSerial0__1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var AggregateQueryClass;
function AggregateQuery() {
  if (AggregateQueryClass === VOID) {
    class $ {
      constructor(aggregate, condition, property) {
        Companion_getInstance_1();
        condition = condition === VOID ? Always_getInstance() : condition;
        this.aggregate_1 = aggregate;
        this.condition_1 = condition;
        this.property_1 = property;
      }
      toString() {
        return 'AggregateQuery(aggregate=' + this.aggregate_1.toString() + ', condition=' + toString(this.condition_1) + ', property=' + this.property_1.toString() + ')';
      }
      hashCode() {
        var result = this.aggregate_1.hashCode();
        result = imul(result, 31) + this.condition_1.hashCode() | 0;
        result = imul(result, 31) + this.property_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AggregateQuery()))
          return false;
        if (!this.aggregate_1.equals(other.aggregate_1))
          return false;
        if (!this.condition_1.equals(other.condition_1))
          return false;
        if (!this.property_1.equals(other.property_1))
          return false;
        return true;
      }
      static new_com_lightningkite_services_database_AggregateQuery_llps17_k$(seen0, aggregate, condition, property, serializationConstructorMarker) {
        Companion_getInstance_1();
        if (!(5 === (5 & seen0))) {
          throwMissingFieldException(seen0, 5, Companion_getInstance_1().$cachedDescriptor_1);
        }
        var $this = createThis(this);
        $this.aggregate_1 = aggregate;
        if (0 === (seen0 & 2))
          $this.condition_1 = Always_getInstance();
        else
          $this.condition_1 = condition;
        $this.property_1 = property;
        return $this;
      }
    }
    initMetadataForClass($, 'AggregateQuery', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_1});
    AggregateQueryClass = $;
  }
  return AggregateQueryClass;
}
function GroupAggregateQuery$Companion$$childSerializers$_anonymous__px3v0i() {
  return Companion_getInstance().serializer_9w0wvi_k$();
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      constructor() {
        Companion_instance_1 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [lazy(tmp_0, GroupAggregateQuery$Companion$$childSerializers$_anonymous__px3v0i), null, null, null];
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.GroupAggregateQuery', null, 4);
        tmp0_serialDesc.addElement_5pzumi_k$('aggregate', false);
        tmp0_serialDesc.addElement_5pzumi_k$('condition', true);
        tmp0_serialDesc.addElement_5pzumi_k$('groupBy', false);
        tmp0_serialDesc.addElement_5pzumi_k$('property', false);
        this.$cachedDescriptor_1 = tmp0_serialDesc;
      }
      serializer_nrleg8_k$(typeSerial0) {
        return $serializer_1().new_com_lightningkite_services_database_GroupAggregateQuery_$serializer_y2k9yp_k$(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_nrleg8_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_2() {
  if (Companion_instance_1 === VOID)
    new (Companion_1())();
  return Companion_instance_1;
}
var $serializerClass_1;
function $serializer_1() {
  if ($serializerClass_1 === VOID) {
    class $ {
      constructor() {
        return new.target.new_com_lightningkite_services_database_GroupAggregateQuery_$serializer_fm6idg_k$();
      }
      static new_com_lightningkite_services_database_GroupAggregateQuery_$serializer_fm6idg_k$() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.GroupAggregateQuery', $this, 4);
        tmp0_serialDesc.addElement_5pzumi_k$('aggregate', false);
        tmp0_serialDesc.addElement_5pzumi_k$('condition', true);
        tmp0_serialDesc.addElement_5pzumi_k$('groupBy', false);
        tmp0_serialDesc.addElement_5pzumi_k$('property', false);
        $this.descriptor_1 = tmp0_serialDesc;
        return $this;
      }
      serialize_ys5p1t_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_2().$childSerializers_1;
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, tmp2_cached[0].get_value_j01efc_k$(), value.aggregate_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !value.condition_1.equals(Always_getInstance())) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, new (ConditionSerializer())(this.typeSerial0__1), value.condition_1);
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, new (DataClassPathSerializer())(this.typeSerial0__1), value.groupBy_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 3, new (DataClassPathSerializer())(this.typeSerial0__1), value.property_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_ys5p1t_k$(encoder, value instanceof GroupAggregateQuery() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp9_cached = Companion_getInstance_2().$childSerializers_1;
        if (tmp8_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp9_cached[0].get_value_j01efc_k$(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, new (ConditionSerializer())(this.typeSerial0__1), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, new (DataClassPathSerializer())(this.typeSerial0__1), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, new (DataClassPathSerializer())(this.typeSerial0__1), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp8_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp9_cached[0].get_value_j01efc_k$(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, new (ConditionSerializer())(this.typeSerial0__1), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, new (DataClassPathSerializer())(this.typeSerial0__1), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, new (DataClassPathSerializer())(this.typeSerial0__1), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp8_input.endStructure_1xqz0n_k$(tmp0_desc);
        return GroupAggregateQuery().new_com_lightningkite_services_database_GroupAggregateQuery_zre51_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [Companion_getInstance_2().$childSerializers_1[0].get_value_j01efc_k$(), new (ConditionSerializer())(this.typeSerial0__1), new (DataClassPathSerializer())(this.typeSerial0__1), new (DataClassPathSerializer())(this.typeSerial0__1)];
      }
      typeParametersSerializers_fr94fx_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.typeSerial0__1];
      }
      static new_com_lightningkite_services_database_GroupAggregateQuery_$serializer_y2k9yp_k$(typeSerial0) {
        var $this = this.new_com_lightningkite_services_database_GroupAggregateQuery_$serializer_fm6idg_k$();
        $this.typeSerial0__1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_1 = $;
  }
  return $serializerClass_1;
}
var GroupAggregateQueryClass;
function GroupAggregateQuery() {
  if (GroupAggregateQueryClass === VOID) {
    class $ {
      constructor(aggregate, condition, groupBy, property) {
        Companion_getInstance_2();
        condition = condition === VOID ? Always_getInstance() : condition;
        this.aggregate_1 = aggregate;
        this.condition_1 = condition;
        this.groupBy_1 = groupBy;
        this.property_1 = property;
      }
      toString() {
        return 'GroupAggregateQuery(aggregate=' + this.aggregate_1.toString() + ', condition=' + toString(this.condition_1) + ', groupBy=' + this.groupBy_1.toString() + ', property=' + this.property_1.toString() + ')';
      }
      hashCode() {
        var result = this.aggregate_1.hashCode();
        result = imul(result, 31) + this.condition_1.hashCode() | 0;
        result = imul(result, 31) + this.groupBy_1.hashCode() | 0;
        result = imul(result, 31) + this.property_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GroupAggregateQuery()))
          return false;
        if (!this.aggregate_1.equals(other.aggregate_1))
          return false;
        if (!this.condition_1.equals(other.condition_1))
          return false;
        if (!this.groupBy_1.equals(other.groupBy_1))
          return false;
        if (!this.property_1.equals(other.property_1))
          return false;
        return true;
      }
      static new_com_lightningkite_services_database_GroupAggregateQuery_zre51_k$(seen0, aggregate, condition, groupBy, property, serializationConstructorMarker) {
        Companion_getInstance_2();
        if (!(13 === (13 & seen0))) {
          throwMissingFieldException(seen0, 13, Companion_getInstance_2().$cachedDescriptor_1);
        }
        var $this = createThis(this);
        $this.aggregate_1 = aggregate;
        if (0 === (seen0 & 2))
          $this.condition_1 = Always_getInstance();
        else
          $this.condition_1 = condition;
        $this.groupBy_1 = groupBy;
        $this.property_1 = property;
        return $this;
      }
    }
    initMetadataForClass($, 'GroupAggregateQuery', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_2});
    GroupAggregateQueryClass = $;
  }
  return GroupAggregateQueryClass;
}
//region block: exports
export {
  AggregateQuery as AggregateQueryy3011hqgitfl,
  GroupAggregateQuery as GroupAggregateQuery38kwelc2aunpz,
  GroupCountQuery as GroupCountQueryynttufojs10g,
  Companion_getInstance_1 as Companion_getInstance3ouvgkx7lgis5,
  Companion_getInstance_2 as Companion_getInstance1qfdwb51f0ue,
  Companion_getInstance_0 as Companion_getInstance3oqgrjvfi17jk,
};
//endregion

//# sourceMappingURL=GroupCountQuery.mjs.map
